import React from 'react';
import styled from 'styled-components';
import CheckmarkBlack from '../static/checkmark-black.svg';
import CheckmarkGreen from '../static/checkmark-green.svg';
import { GreenTag } from './TagIndicator';

const StyledCheckBox = styled.div`
  width: 24px;
  height: 24px;
  border: 0.8px solid
    ${(p: { isSuccess: boolean }) =>
      p.isSuccess ? GreenTag.foreground : `#DEE7ED`};
  box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.2);
  border-radius: 4.8px;
  ${(p: { isSuccess: boolean }) =>
    p.isSuccess ? `background-color: ${GreenTag.background}` : ``};
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-content: center;
  justify-content: space-around;
  margin: 1rem;
  cursor: pointer;
  -webkit-transition: border 500ms ease-out, box-shadow 500ms ease-out;
  -moz-transition: border 500ms ease-out, box-shadow 500ms ease-out;
  -o-transition: border 500ms ease-out, box-shadow 500ms ease-out;
  transition: border 500ms ease-out, box-shadow 500ms ease-out;
  @media only screen and (max-width: 770px) {
    width: 100%;
  }
`;

const Image = styled.img`
  width: 12px;
  height: 12px;
  opacity: ${(p: { isActive: boolean; isSuccess: boolean }) =>
    p.isActive || p.isSuccess ? `100%` : `0%`};

  transition: opacity 100ms ease-out;
`;

interface CheckBoxProps {
  isActive: boolean;
  isSuccess: boolean;
  onClick: any;
}

export const CheckBox = ({ isActive, isSuccess, onClick }: CheckBoxProps) => {
  return (
    <StyledCheckBox
      onClick={onClick}
      isSuccess={isSuccess}
      className={isActive ? 'active' : ''}
    >
      <Image
        src={isSuccess ? CheckmarkGreen : CheckmarkBlack}
        isActive={isActive}
        isSuccess={isSuccess}
      />
    </StyledCheckBox>
  );
};
